export const syncResultEnum = [
  { name: '同步成功', id: 2 },
  { name: '同步失败', id: 3 },
  { name: '同步中', id: 1 },
  { name: '未同步', id: 0 }
]

export const GROUP_TOUTIAO = [
  {
    title: '任务开关',
    key: 'switch',
    width: '70',
    type: 'basic',
    fixed: true
  },
  {
    title: '任务ID',
    key: 'taskId',
    width: '58',
    type: 'analysis'
  },
  {
    title: '操作',
    key: 'control',
    width: '191'
  },
  {
    title: '账号ID',
    key: 'accountId',
    width: '58',
    type: 'basic'
  },
  {
    title: '账号名称',
    key: 'adAccount',
    width: '150',
    type: 'basic'
  },
  {
    title: '账号简称',
    key: 'adAccountSimpleName',
    width: '202',
    type: 'basic'
  },
  {
    title: '数据关联模式',
    key: 'dataModelText',
    width: '100',
    type: 'basic'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '70',
    type: 'basic'
  },
  {
    title: '计划主ID',
    key: 'advertiserId',
    width: '130',
    type: 'basic'
  },
  {
    title: '任务类型',
    key: 'taskType',
    width: '69',
    type: 'analysis'
  },
  {
    title: '白名单',
    key: 'white',
    width: '58',
    type: 'analysis'
  },
  {
    title: '管理人员',
    key: 'opNames',
    width: '65',
    type: 'basic',
    overflow: true
  },
  {
    title: '项目组',
    key: 'projectGroupNames',
    width: '82',
    type: 'basic',
    overflow: true
  },
  {
    title: '账号状态',
    key: 'accountStatus',
    width: '65',
    type: 'analysis'
  },
  {
    title: '任务状态',
    key: 'taskStatus',
    width: '65',
    type: 'analysis'
  },
  {
    title: '同步结果',
    key: 'synStatus',
    width: '108',
    type: 'analysis',
    format({ row }) {
      const { synStatus, remark } = row
      const { name } = syncResultEnum.find((s) => s.id === synStatus) || {}
      if (name) {
        // 追加失败原因
        if (synStatus === 3) {
          return name.concat(':').concat(remark)
        }
        return name
      }
      return '-'
    },
    overflow: true
  },
  {
    title: '昨日余额',
    key: 'yestMoney',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '今日实时余额',
    key: 'accountMoney',
    width: '112',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '近3日均消耗',
    key: 'lastThreeDaysConsume',
    width: '108',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '上个月消耗',
    key: 'lastMonthAmount',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '无消耗天数',
    key: 'noConsumeDays',
    width: '82',
    type: 'report'
  },
  {
    title: '预计还能消耗天数',
    key: 'estRemainDays',
    width: '82',
    type: 'report'
  },
  {
    title: '代理商',
    key: 'agentName',
    width: '94',
    type: 'analysis',
    overflow: true
  },

  {
    title: '开票主体',
    key: 'invoiceUnit',
    width: '94',
    type: 'analysis',
    overflow: true
  },
  {
    title: '开户主体',
    key: 'companyName',
    width: '94',
    type: 'analysis',
    overflow: true
  },

  {
    title: '返点',
    key: 'finaRebate',
    width: '94',
    type: 'analysis',
    overflow: true
  },
  {
    title: '结算方式',
    key: 'settleTypeName',
    width: '94',
    type: 'analysis',
    overflow: true
  },
  {
    title: '最后同步时间',
    key: 'lastSynTime',
    width: '125',
    type: 'analysis'
  },
  {
    title: '新建人',
    key: 'name',
    width: '94',
    type: 'analysis'
  },
  {
    title: '任务新建时间',
    key: 'createTime',
    width: '140',
    type: 'analysis'
  }
]
